var _path, _path2, _path3, _path4, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _path5, _mask8, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6027 2.85266H3.3829C3.11006 2.85266 2.84907 2.96418 2.66048 3.16134C2.29078 3.54785 2.29078 4.15686 2.66048 4.54337C2.84907 4.74053 3.11006 4.85205 3.3829 4.85205H44.6027C44.8755 4.85205 45.1365 4.74053 45.3251 4.54337C45.6948 4.15687 45.6948 3.54785 45.3251 3.16134C45.1365 2.96418 44.8755 2.85266 44.6027 2.85266Z",
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 1.19963
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6027 44.8397H3.3829C3.11006 44.8397 2.84907 44.9512 2.66048 45.1484C2.29078 45.5349 2.29078 46.1439 2.66048 46.5304C2.84907 46.7276 3.11006 46.8391 3.3829 46.8391H44.6027C44.8755 46.8391 45.1365 46.7276 45.3251 46.5304C45.6948 46.1439 45.6948 45.5349 45.3251 45.1484C45.1365 44.9512 44.8755 44.8397 44.6027 44.8397Z",
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 1.19963
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99878 4.85193V44.8397",
    stroke: "#A3AED0",
    strokeWidth: 2.09936
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9866 4.85193V44.8397",
    stroke: "#A3AED0",
    strokeWidth: 2.09936
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.99756,
    y: 8.85071,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.99756,
    y: 8.85071,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-5-inside-1_573_4094)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9939,
    y: 8.85071,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9939,
    y: 8.85071,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-6-inside-2_573_4094)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.9902,
    y: 8.85071,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9902,
    y: 8.85071,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-7-inside-3_573_4094)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.99756,
    y: 20.8472,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.99756,
    y: 20.8472,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-8-inside-4_573_4094)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9939,
    y: 20.8472,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9939,
    y: 20.8472,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-9-inside-5_573_4094)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-6_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.9902,
    y: 20.8472,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9902,
    y: 20.8472,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-10-inside-6_573_4094)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-7_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.9902,
    y: 32.8434,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9902,
    y: 32.8434,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-11-inside-7_573_4094)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99725 33.4432H14.9954C15.2163 33.4432 15.3953 33.6222 15.3953 33.8431V39.8412C15.3953 40.0621 15.2163 40.2411 14.9954 40.2411H8.99725C8.77641 40.2411 8.59738 40.0621 8.59738 39.8412V33.8431C8.59738 33.6222 8.77641 33.4432 8.99725 33.4432Z",
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 1.19963,
    strokeLinejoin: "round"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-8_573_4094",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9939,
    y: 32.8434,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9939,
    y: 32.8434,
    width: 7.99756,
    height: 7.99756,
    rx: 0.999694,
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinejoin: "round",
    mask: "url(#path-13-inside-8_573_4094)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaades);
export default __webpack_public_path__ + "static/media/Façades.e5e9363336732ac425c8f6f06e212fc2.svg";
export { ForwardRef as ReactComponent };